import React from 'react';
import { MonitoredByCompanyTypes } from 'store/modules/monitoring_store/types';
import { companyInitials, compactCompanies, monitoredByText } from 'services/company_initials';
import { Container } from './styles';

interface MonitoredByCompaniesProps {
  companies: Array<MonitoredByCompanyTypes>;
  tradingPosition: number;
}

const MonitoredByCompanies = ({ companies: all, tradingPosition }: MonitoredByCompaniesProps) => {
  const companies = all.filter((company) => company.visivel !== false);
  if (companies.length === 0) return null;

  return (
    <Container
      className="databalloon"
      aria-label={monitoredByText(companies.map((company) => company.nome))}
      data-balloon-pos={tradingPosition < 2 ? 'down-right' : 'up-right'}
      data-balloon-length="large"
      data-balloon-blunt
    >
      {compactCompanies(companies).map((item) => (
        <span className="company-initials" key={typeof item === 'number' ? 'mais' : item.id}>
          {typeof item === 'number' ? `+${item}` : companyInitials(item.nome)}
        </span>
      ))}
    </Container>
  );
};

export default MonitoredByCompanies;
